/**
 * BBS Global logo — uses the official company logo PNG.
 * Applies a CSS crop (via scale + overflow:hidden) to trim the whitespace
 * padding baked into the source image, making the visible mark ~30% larger
 * within the same rendered footprint.
 */
const LOGO_URL = "https://customer-assets.emergentagent.com/job_assetiq-pro/artifacts/u6ddmd1a_Logo%20for%20Google%20Forms.png";

// Source image is 1046x400 (aspect ~2.615). It has ~12% padding on each side.
// A scale of 1.28 with overflow:hidden crops the padding cleanly.
const SCALE = 1.28;
const ASPECT = 1046 / 400;

export default function BBSLogo({ className = "", size = 40 }) {
  // `size` = target visible height in px
  const height = size;
  const width = Math.round(size * ASPECT * 0.82); // account for cropped width
  return (
    <div
      className={`inline-flex items-center overflow-hidden ${className}`}
      style={{ height: `${height}px`, width: `${width}px` }}
      data-testid="bbs-logo"
    >
      <img
        src={LOGO_URL}
        alt="BBS Global Pvt. Ltd."
        style={{
          height: `${height}px`,
          width: "auto",
          transform: `scale(${SCALE})`,
          transformOrigin: "center center",
        }}
        className="object-contain select-none pointer-events-none"
        draggable={false}
      />
    </div>
  );
}
